if (!customElements.get("product-form")) {
  var availabilityMsg = document.querySelector(".availabilityMsg");
  var avaliablepincode = window.pincodes.pincodeData;
  var avaliablepindeoArr = avaliablepincode.split(",");
  document.getElementById("closePopup").addEventListener("click", function () {
    document.getElementById("pincodePopup").style.display = "none";
    document.querySelector(".pincodeOverlay").style.display = "none";
  });
  var tgt_main_atc = document.getElementById("main-buy-btn");
  var pdp_subscribe = document.getElementById("pdp_subscribe_main");
  var addproduct;
  var subscribe_add_product;
  pdp_subscribe?.addEventListener("click", function () {
    if (pdp_subscribe_main.classList.contains("main_subscribe_not_allowed")) {
      return;
    }
    let tgtcheckpincodepopup = localStorage.getItem("pincodevalue");
    if (!tgtcheckpincodepopup) {
      subscribe_add_product = pdp_subscribe
        .closest(".buy_subscribe_block")
        ?.querySelector("product-form");
      document.getElementById("pincodePopup").style.display = "block";
      document.querySelector(".pincodeOverlay").style.display = "block";
    } else {
      pdp_subscribe_container.style.display = "block";
      pdp_subscribe.style.display = "none";
      tgt_main_atc.style.display = "none";
    }
  });
  document
    .getElementById("checkAvailability")
    .addEventListener("click", async function () {
      let tgtpincodevalue = document.getElementById("pincodeInput").value;
      if (addproduct) {
        var check_product_atc = addproduct.classList.contains("product-form");
        let tgtproductpincode = addproduct
          .querySelector("button")
          .getAttribute("pincode-data");
        let tgtpincodeData = tgtproductpincode.split(",");
        validatepincode = tgtpincodeData.some((item) => {
          return item === tgtpincodevalue;
        });
        if (validatepincode) {
          availabilityMsg.textContent = "Service not avaliable";
          availabilityMsg.style.color = "red";
        } else {

          const reqData = {
            pincode: tgtpincodevalue,
          };

          const encrypted = CryptoUtil.encryptRequest("GET", reqData);

          let pincodeResponse = await fetch(`${window.Base_Url.Base_Url}/api/auth/V3/GetStatusV3?iv=${encodeURIComponent(encrypted.iv)}&payload=${encodeURIComponent(encrypted.payload)}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "seal": encrypted.seal
            }
          });
          let result = await pincodeResponse.json();
          const pincoderesponseData = CryptoUtil.decryptResponse(result);
          let newpincodemessage = pincoderesponseData?.message;
          if (newpincodemessage == "Pincode not found") {
            availabilityMsg.textContent = "Please Enter Valid pincode";
            availabilityMsg.style.color = "red";
            return;
          }

           if (!newpincodemessage && pincoderesponseData.status==false) {
            availabilityMsg.textContent = "Service not avaliable";
            availabilityMsg.style.color = "red";
            return;
          }
          // let checkavaliablepincode =    avaliablepindeoArr.some((item)=>{
          //      return item ==tgtpincodevalue
          //    })
          let checkavaliablepincode = pincoderesponseData.status;
          if (checkavaliablepincode) {
               const myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");
                  const pincode = {
                    pincode:tgtpincodevalue
                  }                  
                  const Key = window.generateRandomString(32);
                  const payload = window.Encrypt(pincode, Key);
                  const sealValue = window.md5(`${payload}${Key}`);
                  myHeaders.append("sealvalue", sealValue);
                  myHeaders.append("key", Key);
                  fetch(`${window.Base_Url.Base_Url}/google-map/geocode?data=${encodeURIComponent(payload)}`, {
                    method: 'GET',
                    headers: myHeaders
                  })
                    .then(response => response.text()) // Assuming response is plain text
                    .then(result => {
                      const plainData = result.split("|")[0];
                      const EncKey = result.split("|")[1].split("%%")[0];
                      const data = window.Decrypt(plainData, EncKey);                             
                      if (data.results && data.results.length > 0) {
                        const addressComponents = data.results[0].address_components;                 
                        const cityComponent = addressComponents.find(component => component.types.includes("locality"));
                        const newcity = cityComponent ? cityComponent.long_name : "";                
                        const stateComponent = addressComponents.find(component => component.types.includes("administrative_area_level_1"));
                        const newstate = stateComponent ? stateComponent.long_name : "";                  
                        localStorage.setItem("PincodeCity", newcity);
                        document.getElementById("pincodeCIty").textContent = `${newcity},`;
                      }
                    })
                    .catch(error => {
                      console.error("Fetch error:", error);
                    });
            localStorage.setItem("pincodevalue", tgtpincodevalue);

            document.getElementById("pincodePopup").style.display = "none";
            document.querySelector(".pincodeOverlay").style.display = "none";
            document.querySelector(".productPincode").style.display = "flex";
            document.querySelector(".pincodeValue").textContent =
              tgtpincodevalue;
            let tgt_product_redeem = addproduct;
            let tgt_redeem_product_status = addproduct
              .querySelector("button")
              .getAttribute("redeem_product_status");
            let tgt_redeem_product_exipred = addproduct
              .querySelector("button")
              .getAttribute("redeem_product_expired");
            let tgt_customer_point = addproduct
              .querySelector("button")
              .getAttribute("customer_point");
            let tgt_product_price = addproduct
              .querySelector("button")
              .getAttribute("product_price");
            if (tgt_redeem_product_status === "true") {
              let tgt_normal_product_added = localStorage.getItem(
                "normal_product_added"
              );
              if (tgt_normal_product_added) {
                document.getElementById("redeem_point_error").style.display =
                  "block";
                document.getElementById("redeem_point_error").textContent =
                  "Normal product is already Added";
                setTimeout(function () {
                  document.getElementById("redeem_point_error").style.display =
                    "none";
                }, 3000);
                return;
              }
              localStorage.setItem("redeem_product", true);
              tgt_redeem_product_exipred = tgt_redeem_product_exipred.replace(
                /['"]/g,
                ""
              );
              let expirationDate = new Date(tgt_redeem_product_exipred);

              let currentDate = new Date();

              if (currentDate > expirationDate) {
                document.getElementById("redeem_point_error").style.display =
                  "block";
                document.getElementById("redeem_point_error").textContent =
                  "This product is expired";
                return;
              } else {
                console.log("Redeem product is still valid.");
                // You can place further logic here if needed
              }
              if (tgt_customer_point < tgt_product_price) {
                console.log("Customer points: ",tgt_customer_point);
                document.getElementById("redeem_point_error").style.display =
                  "block";
                document.getElementById(
                  "redeem_point_error"
                ).textContent = `You do not have enough points to redeem this product`;
                return false;
              } else {
                console.log(
                  "Customer points are sufficient. Product can be added."
                );
                // Proceed with adding the product to the cart
              }
            } else {
             
              let tgt_redeem_product = localStorage.getItem("redeem_product");
              if (tgt_redeem_product) {
                let tgt_redemption_addto_cart_erorr = document.querySelector(
                  ".product_card_product_service"
                );
                if (tgt_redemption_addto_cart_erorr) {
                  tgt_redemption_addto_cart_erorr.style.display = "block";
                  tgt_redemption_addto_cart_erorr.textContent =
                    "Redemption product is already added";
                  setTimeout(function () {
                    tgt_redemption_addto_cart_erorr.style.display = "none";
                  }, 3000);
                }
                if (addproduct.querySelector(".redemption_product_error")) {
                  addproduct.querySelector(
                    ".redemption_product_error"
                  ).style.display = "block";
                  let tgt_redeem_error = addproduct.querySelector(
                    ".redemption_product_error"
                  );
                  setTimeout(function () {
                    tgt_redeem_error.style.display = "none";
                  }, 3000);
                }
                return;
              }
            localStorage.setItem("normal_product_added", true);
            }

            if (
              addproduct.submitButton.getAttribute("aria-disabled") === "true"
            )
              return;

            addproduct.handleErrorMessage();

            addproduct.submitButton.setAttribute("aria-disabled", true);
            addproduct.submitButton.classList.add("loading");
            addproduct
              .querySelector(".loading__spinner")
              .classList.remove("hidden");

            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            delete config.headers["Content-Type"];

            const formData = new FormData(addproduct.form);
            if (addproduct.cart) {
              formData.append(
                "sections",
                addproduct.cart
                  .getSectionsToRender()
                  .map((section) => section.id)
              );
              formData.append("sections_url", window.location.pathname);
              addproduct.cart.setActiveElement(document.activeElement);
            }
            config.body = formData;
            const cartData = await getCartJson();
            let maxcapping =
              addproduct.submitButton.getAttribute("max-capping");
            let mincapping =
              addproduct.submitButton.getAttribute("min-capping");
            let productId = formData.get("id");
            let checkproductcart = cartData.items.find((item) => {
              return item.id.toString() == productId;
            });
            if (check_product_atc) {
              let tgt_product_inputt = document.querySelector(
                ".product_input_qyt_value"
              );
              let tgt_product_inputt_value = tgt_product_inputt.value;

              // Check if mincapping is undefined, null, or empty, then assign tgt_product_inputt_value
              if (!mincapping) {
                mincapping = tgt_product_inputt_value;
              } else {
                // If tgt_product_inputt_value is less than mincapping, do not update the value
                if (tgt_product_inputt_value >= mincapping) {
                  mincapping = tgt_product_inputt_value;
                }
              }
            }
            if (config.body instanceof FormData) {
              if (!checkproductcart) {
                config.body.append("quantity", mincapping);
              } else {
                let currentQuantity = checkproductcart.quantity;
                if (maxcapping && currentQuantity >= maxcapping) {
                  addproduct.submitButton
                    .closest("form")
                    .querySelector(".maximun_quantity").style.display = "block";
                  addproduct.submitButton.classList.remove("loading");
                  if (
                    addproduct.cart &&
                    addproduct.cart.classList.contains("is-empty")
                  )
                    addproduct.cart.classList.remove("is-empty");
                  if (!addproduct.error)
                    addproduct.submitButton.removeAttribute("aria-disabled");
                  setTimeout(() => {
                    addproduct.submitButton
                      .closest("form")
                      .querySelector(".maximun_quantity").style.display =
                      "none";
                  }, 3000);
                  addproduct
                    .querySelector(".loading__spinner")
                    .classList.add("hidden");
                  return; // Stop further processing
                } else {
                  config.body.append("quantity", 1);
                }
              }
            }
            fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  addproduct.handleErrorMessage(response.description);

                  const soldOutMessage =
                    addproduct.submitButton.querySelector(".sold-out-message");
                  if (!soldOutMessage) return;
                  addproduct.submitButton.setAttribute("aria-disabled", true);
                  addproduct.submitButton
                    .querySelector("span")
                    .classList.add("hidden");
                  soldOutMessage.classList.remove("hidden");
                  addproduct.error = true;
                  return;
                } else if (!addproduct.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                if (!addproduct.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "product-form",
                    productVariantId: formData.get("id"),
                    cartData: response,
                  });
                addproduct.error = false;
                const quickAddModal = addproduct.closest("quick-add-modal");
                if (quickAddModal) {
                  document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        addproduct.cart.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  // addproduct.cart.renderContents(response);
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                addproduct.submitButton.classList.remove("loading");
                if (
                  addproduct.cart &&
                  addproduct.cart.classList.contains("is-empty")
                )
                  addproduct.cart.classList.remove("is-empty");
                if (!addproduct.error)
                  addproduct.submitButton.removeAttribute("aria-disabled");
                addproduct
                  .querySelector(".loading__spinner")
                  .classList.add("hidden");
                location.reload();
              });
          } else {
            availabilityMsg.textContent = "Service not available";
            availabilityMsg.style.color = "red";
          }
        }
      } else {
        let tgtproductpincode = subscribe_add_product
          .querySelector("button")
          .getAttribute("pincode-data");
        let tgtpincodeData = tgtproductpincode.split(",");
        validatepincode = tgtpincodeData.some((item) => {
          return item === tgtpincodevalue;
        });
        if (validatepincode) {
          availabilityMsg.textContent = "Service not avaliable";
          availabilityMsg.style.color = "red";
        } else {

          const reqData = {
            pincode: tgtpincodevalue,
          }

          const encrypted = CryptoUtil.encryptRequest("GET", reqData);

          let pincodeResponse = await fetch(`${window.Base_Url.Base_Url}/api/auth/V3/GetStatusV3?iv=${encodeURIComponent(encrypted.iv)}&payload=${encodeURIComponent(encrypted.payload)}`,{
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "seal": encrypted.seal
            }
          });
          let result = await pincodeResponse.json();
          const pincoderesponseData = CryptoUtil.decryptResponse(result);
          let checkavaliablepincode = pincoderesponseData.status;
          // let checkavaliablepincode =    avaliablepindeoArr.some((item)=>{
          //      return item ==tgtpincodevalue
          //    })
          let newpincodemessage = pincoderesponseData?.message;
          if (newpincodemessage == "Pincode not found") {
            availabilityMsg.textContent = "Please Enter Valid pincode";
            availabilityMsg.style.color = "red";
            return;
          }
          if (!newpincodemessage && pincoderesponseData.status==false) {
            availabilityMsg.textContent = "Service not avaliable";
            availabilityMsg.style.color = "red";
            return;
          }
          if (checkavaliablepincode) {
              const myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");
                  const pincode = {
                    pincode:tgtpincodevalue
                  }                  
                  const Key = window.generateRandomString(32);
                  const payload = window.Encrypt(pincode, Key);
                  const sealValue = window.md5(`${payload}${Key}`);
                  myHeaders.append("sealvalue", sealValue);
                  myHeaders.append("key", Key);
                  fetch(`${window.Base_Url.Base_Url}/google-map/geocode?data=${encodeURIComponent(payload)}`, {
                    method: 'GET',
                    headers: myHeaders
                  })
                    .then(response => response.text()) // Assuming response is plain text
                    .then(result => {
                      const plainData = result.split("|")[0];
                      const EncKey = result.split("|")[1].split("%%")[0];
                      const data = window.Decrypt(plainData, EncKey);                             
                      if (data.results && data.results.length > 0) {
                        const addressComponents = data.results[0].address_components;                 
                        const cityComponent = addressComponents.find(component => component.types.includes("locality"));
                        const newcity = cityComponent ? cityComponent.long_name : "";                
                        const stateComponent = addressComponents.find(component => component.types.includes("administrative_area_level_1"));
                        const newstate = stateComponent ? stateComponent.long_name : "";                  
                        localStorage.setItem("PincodeCity", city_new);
                        document.getElementById("pincodeCIty").textContent = `${city_new},`;
                      }
                    })
                    .catch(error => {
                      console.error("Fetch error:", error);
                    });
            localStorage.setItem("pincodevalue", tgtpincodevalue);

            document.getElementById("pincodePopup").style.display = "none";
            document.querySelector(".pincodeOverlay").style.display = "none";
            document.querySelector(".productPincode").style.display = "flex";
            document.querySelector(".pincodeValue").textContent =
              tgtpincodevalue;
            pdp_subscribe_container.style.display = "block";
            pdp_subscribe.style.display = "none";
            tgt_main_atc.style.display = "none";
          } else {
            availabilityMsg.textContent = "Service not available";
          }
        }
      }
    });
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        let cart_clear = await fetch("/checkout?discount=CLEAR")
        let checkpincodeisset = localStorage.getItem("pincodevalue");
        if (checkpincodeisset) {
          const checkcartsub = await getCartJson();
          if (this.submitButton.getAttribute("aria-disabled") === "true")
            return;
          let tgt_check_product = checkcartsub.items.some((item) => {
            return (
              item.properties && item.properties.subscribe_product == "product"
            );
          });

          if (tgt_check_product) {
            let tgt_more_product_none =
              document.getElementById("more_product_none");
            if (tgt_more_product_none) {
              tgt_more_product_none.classList.remove("more_product_none");
              setTimeout(function () {
                tgt_more_product_none.classList.add("more_product_none");
              }, 3000);
              return;
            } else {
              let subscribe_card_error =
                this.closest(".card__content").querySelector(
                  ".subscribe_error"
                );
              subscribe_card_error.style.display = "block";
              setTimeout(() => {
                subscribe_card_error.style.display = "none";
              }, 3000);
              return;
            }
          }

          /* Product Pincode Popup */
          // const pincode = localStorage.getItem('Pincode');
          // if(!pincode) {
          //   window.showPopup();
          //   return;
          // }
          /* Product Pincode Popup */
          let tgt_redeem_product_status = this.submitButton.getAttribute(
            "redeem_product_status"
          );
          let tgt_redeem_product_exipred = this.submitButton.getAttribute(
            "redeem_product_expired"
          );
          let tgt_customer_point =
            this.submitButton.getAttribute("customer_point");
          let tgt_product_price =
            this.submitButton.getAttribute("product_price");

          // Convert customer points and product price to numbers
          tgt_customer_point = Number(tgt_customer_point);
          tgt_product_price = Number(tgt_product_price);

          if (tgt_redeem_product_status === "true") {
            let tgt_normal_product_added = localStorage.getItem(
              "normal_product_added"
            );
            if (tgt_normal_product_added) {
              document.getElementById("redeem_point_error").style.display =
                "block";
              document.getElementById("redeem_point_error").textContent =
                "Normal product is already Added";
              setTimeout(function () {
                document.getElementById("redeem_point_error").style.display =
                  "none";
              }, 3000);
              return;
            }
            localStorage.setItem("redeem_product", true);
            tgt_redeem_product_exipred = tgt_redeem_product_exipred.replace(
              /['"]/g,
              ""
            );
            let expirationDate = new Date(tgt_redeem_product_exipred);
            let currentDate = new Date();

            // Check if the product is expired
            if (currentDate > expirationDate) {
              document.getElementById("redeem_point_error").style.display =
                "block";
              document.getElementById("redeem_point_error").textContent =
                "This product is expired";
              return false;
            } else {
              // Check if customer points are sufficient for the product price
              if (tgt_customer_point < tgt_product_price) {
                console.log("Balance point : ", tgt_customer_point);
                document.getElementById("redeem_point_error").style.display =
                  "block";
                document.getElementById(
                  "redeem_point_error"
                ).textContent = `You do not have enough points to redeem this product`;
                return false;
              } else {
                console.log(
                  "Customer points are sufficient. Product can be added."
                );
                // Proceed with adding the product to the cart
              }
            }
          } else {
           
            let tgt_redeem_product = localStorage.getItem("redeem_product");
            if (tgt_redeem_product) {
              let tgt_redemption_addto_cart_erorr = document.querySelector(
                ".product_card_product_service"
              );
              if (tgt_redemption_addto_cart_erorr) {
                tgt_redemption_addto_cart_erorr.style.display = "block";
                tgt_redemption_addto_cart_erorr.textContent =
                  "Redemption product is already added";
                setTimeout(function () {
                  tgt_redemption_addto_cart_erorr.style.display = "none";
                }, 3000);
              }
              if (
                this.submitButton
                  .closest("form")
                  .querySelector(".redemption_product_error")
              ) {
                this.submitButton
                  .closest("form")
                  .querySelector(".redemption_product_error").style.display =
                  "block";
                let tgt_redeem_error = this.submitButton
                  .closest("form")
                  .querySelector(".redemption_product_error");
                setTimeout(function () {
                  tgt_redeem_error.style.display = "none";
                }, 3000);
              }
              return;
            }
             localStorage.setItem("normal_product_added", true);
          }

          this.handleErrorMessage();

          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
          this.querySelector(".loading__spinner").classList.remove("hidden");

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            if (tgt_redeem_product_status == "true") { formData.append("properties[productType]", "Reedem") }
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          const cartData = await getCartJson();
          let maxcapping = this.submitButton.getAttribute("max-capping");
          let mincapping = this.submitButton.getAttribute("min-capping");
          if (!mincapping) {
            mincapping = 1;
          }
          if (!maxcapping) {
            maxcapping = 5;
          }
          let productId = formData.get("id");
          let checkproductcart = cartData.items.find((item) => {
            return item.id.toString() == productId;
          });
          var check_product_atc = this.classList.contains("product-form");
          if (check_product_atc) {
            let tgt_product_inputt = document.querySelector(
              ".product_input_qyt_value"
            );
            let tgt_product_inputt_value = tgt_product_inputt.value;

            // Check if mincapping is undefined, null, or empty, then assign tgt_product_inputt_value
            if (!mincapping) {
              mincapping = tgt_product_inputt_value;
            } else {
              // If tgt_product_inputt_value is less than mincapping, do not update the value
              // if (tgt_product_inputt_value >= mincapping) {
              mincapping = tgt_product_inputt_value;
              // }
            }
            let tgt_product_inputtt = document.querySelector(
              ".product_input_qyt_value"
            );
            let tgt_product_inputt_valuee = tgt_product_inputtt.value;
            if (tgt_product_inputt_valuee == 0) {
              let tgt_max_qty_error = document.querySelector(
                ".subscription_qty_error"
              );
              tgt_max_qty_error.style.display = "block";
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");
              setTimeout(function () {
                tgt_max_qty_error.style.display = "none";
              }, 3000);

              return;
            }
          }

          if (config.body instanceof FormData) {
            if (!checkproductcart) {
              config.body.append("quantity", mincapping);
            } else {
              let currentQuantity = checkproductcart.quantity;
              if (maxcapping && currentQuantity >= maxcapping) {
                if (
                  this.submitButton
                    .closest("form")
                    .querySelector(".maximun_quantity")
                ) {
                  this.submitButton
                    .closest("form")
                    .querySelector(".maximun_quantity").style.display = "block";
                } else {
                  this.submitButton
                    .closest("product-info")
                    .querySelector(".maximun_quantity").style.display = "block";
                }

                this.submitButton.classList.remove("loading");
                if (this.cart && this.cart.classList.contains("is-empty"))
                  this.cart.classList.remove("is-empty");
                if (!this.error)
                  this.submitButton.removeAttribute("aria-disabled");
                this.querySelector(".loading__spinner").classList.add("hidden");
                setTimeout(() => {
                  if (
                    this.submitButton
                      .closest("form")
                      .querySelector(".maximun_quantity")
                  ) {
                    this.submitButton
                      .closest("form")
                      .querySelector(".maximun_quantity").style.display =
                      "none";
                  } else {
                    this.submitButton
                      .closest("product-info")
                      .querySelector(".maximun_quantity").style.display =
                      "none";
                  }
                }, 3000);
                return; // Stop further processing
              } else {
                if (check_product_atc) {
                  config.body.append("quantity", mincapping);
                } else {
                  config.body.append("quantity", 1);
                }
              }
            }
          }
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");
            });
        } else {
          addproduct = this;
          document.getElementById("pincodePopup").style.display = "block";
          document.querySelector(".pincodeOverlay").style.display = "block";
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          document.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          document.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );

  const getCartJson = async () => {
    try {
      const res = await fetch("/cart.json");
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      const resData = await res.json();
      return resData;
    } catch (error) {
      console.error("Error fetching cart data:", error);
      return null;
    }
  };
}
